<template>
  <div class="static-topbar">
    <div class="container mx-auto">
      <nuxt-link to="/">
        <img
          class="player-image"
          src="~/assets/images/logo-kognisi.svg"
          width="108"
          alt="kognisi logo"
          loading="lazy"
        />
      </nuxt-link>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use './styles.scss';
</style>
